import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { t } from "@lingui/macro";

import { useUserStore, useAccountStore } from "base/stores";
import { USER_POPUP_OPTIONS } from "base/constants";

import {
  Popover,
  POPOVER_TRIGGERS,
  POPOVER_POSITIONS
} from "../../feedback/popover/index.jsx";
import {
  Button,
  BUTTON_SIZES,
  BUTTON_TYPES
} from "../../inputs/button/index.jsx";
import { UserIcon, AVATAR_SIZE } from "../../datadisplay/usericon/index.jsx";

import styles from "./usercard.css";

/**
 * User card  with username if user hover the name they will see the information of the user
 */
export function UserCard(props) {
  let {
    userId,
    name,
    children,
    position = POPOVER_POSITIONS.TOP,
    actions,
    hiddenTypes = []
  } = props;
  const user = useUserStore((state) => state.users[userId]);
  const { UserDetails } = useAccountStore.getState();
  const onlyAdminCanCreate =
    window.accountDetails.UserDetails.AccountDetails.FlowControl.Chat
      ?.ApprovalRule || "";
  const isSuperAdmin = useUserStore.getState().isSuperAdmin();
  let defaultActions = [
    {
      type: USER_POPUP_OPTIONS.MESSAGE,
      text: t`Message`,
      action: () => {
        document.dispatchEvent(
          new CustomEvent("CHAT:INITIATE", {
            detail: { _id: userId, Name: name }
          })
        );
      },
      buttonType: BUTTON_TYPES.SECONDARY
    }
  ];

  if (
    UserDetails._id === userId ||
    (useUserStore.getState().currentUser?.AccountDetails?.FlowControl?.Chat
      ?.IsDisabled &&
      USER_POPUP_OPTIONS.MESSAGE.length)
  ) {
    defaultActions = defaultActions.filter(
      (action) => action.type !== USER_POPUP_OPTIONS.MESSAGE
    );
  }
  actions =
    actions ||
    defaultActions.filter((action) => !hiddenTypes.includes(action.type));
  return (
    <Popover
      targetRenderer={() => children}
      trigger={[POPOVER_TRIGGERS.HOVER]}
      position={position}
      getContainer={() => document.body}
    >
      <div className={styles.userCard}>
        <div>
          <UserIcon userId={userId} name={name} size={AVATAR_SIZE.SIZE96} />
        </div>
        <span className={`${styles.name} base-600`}>
          {name || (user && user.Name)}
        </span>
        {user && user.Designation && (
          <span className={`${styles.designation} micro`}>
            {user.Designation}
          </span>
        )}
        {actions.length ? (
          <div className={styles.actions}>
            {actions?.map((act, index) => {
              let isMessageAction = act.type === USER_POPUP_OPTIONS.MESSAGE;
              if (isMessageAction && onlyAdminCanCreate && !isSuperAdmin)
                return null;
              return (
                <Button
                  onClick={act.action}
                  type={act.buttonType}
                  size={BUTTON_SIZES.SMALL}
                  key={`profile_action_${index}`}
                >
                  {act.text}
                </Button>
              );
            })}
          </div>
        ) : null}
      </div>
    </Popover>
  );
}

UserCard.propTypes = {
  /** child node of UserCard */
  children: PropTypes.node.isRequired,
  /** Id of the user in UserCard*/
  userId: PropTypes.string.isRequired,
  /** name of the user in the UserCard */
  name: PropTypes.string,
  /** array of actions performed by the UserCard  */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.func,
      buttonType: PropTypes.string,
      text: PropTypes.string,
      type: PropTypes.string
    })
  ),
  /** Position of the UserCard */
  position: PropTypes.oneOf(Object.values(POPOVER_POSITIONS)),
  /** hide actions based on the hiddenTypes will execute when actions was null and store's default actions exists  */
  hiddenTypes: PropTypes.arrayOf(PropTypes.string)
};

UserCard.defaultProps = {
  userId: "",
  name: "",
  children: {},
  position: POPOVER_POSITIONS.TOP,
  hiddenTypes: []
};
